import { SVGProps, Ref, forwardRef } from "react";

const FilledFolderCloseIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    ref={ref}
    {...props}
  >
    <title id="Folder Close Icon">Folder Close Icon</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 1.5C1.79086 1.5 0 3.29086 0 5.5V9.9V9.97699V16.1C0 18.3402 0 19.4603 0.435974 20.316C0.819467 21.0686 1.43139 21.6805 2.18404 22.064C3.03969 22.5 4.15979 22.5 6.4 22.5H17.6C19.8402 22.5 20.9603 22.5 21.816 22.064C22.5686 21.6805 23.1805 21.0686 23.564 20.316C24 19.4603 24 18.3402 24 16.1V9.9C24 7.65979 24 6.53968 23.564 5.68404C23.1805 4.93139 22.5686 4.31947 21.816 3.93597C20.9603 3.5 19.8402 3.5 17.6 3.5H13.2859C11.3991 3.5 9.60237 1.5 7.71548 1.5H4Z"
      fill="#506C99"
    />
    <path
      d="M0.435974 20.316L0.881477 20.089H0.881477L0.435974 20.316ZM2.18404 22.064L2.41103 21.6185L2.18404 22.064ZM21.816 22.064L21.589 21.6185L21.816 22.064ZM23.564 20.316L23.1185 20.089L23.564 20.316ZM23.564 5.68404L23.1185 5.91103V5.91103L23.564 5.68404ZM21.816 3.93597L21.589 4.38148V4.38148L21.816 3.93597ZM0 5.5H0.5C0.5 3.567 2.067 2 4 2V1.5V1C1.51472 1 -0.5 3.01472 -0.5 5.5H0ZM0 9.9H0.5V5.5H0H-0.5V9.9H0ZM0 9.97699H0.5V9.9H0H-0.5V9.97699H0ZM0 16.1H0.5V9.97699H0H-0.5V16.1H0ZM0.435974 20.316L0.881477 20.089C0.705391 19.7434 0.604807 19.3226 0.552836 18.6865C0.500389 18.0446 0.5 17.2284 0.5 16.1H0H-0.5C-0.5 17.2119 -0.500389 18.0758 -0.443843 18.7679C-0.38682 19.4658 -0.269417 20.0329 -0.00952922 20.543L0.435974 20.316ZM2.18404 22.064L2.41103 21.6185C1.75247 21.283 1.21703 20.7475 0.881477 20.089L0.435974 20.316L-0.00952944 20.543C0.421901 21.3897 1.11031 22.0781 1.95704 22.5095L2.18404 22.064ZM6.4 22.5V22C5.27164 22 4.45545 21.9996 3.81352 21.9472C3.17744 21.8952 2.75662 21.7946 2.41103 21.6185L2.18404 22.064L1.95704 22.5095C2.4671 22.7694 3.03416 22.8868 3.73209 22.9438C4.42418 23.0004 5.28815 23 6.4 23V22.5ZM17.6 22.5V22H6.4V22.5V23H17.6V22.5ZM21.816 22.064L21.589 21.6185C21.2434 21.7946 20.8226 21.8952 20.1865 21.9472C19.5446 21.9996 18.7284 22 17.6 22V22.5V23C18.7119 23 19.5758 23.0004 20.2679 22.9438C20.9658 22.8868 21.5329 22.7694 22.043 22.5095L21.816 22.064ZM23.564 20.316L23.1185 20.089C22.783 20.7475 22.2475 21.283 21.589 21.6185L21.816 22.064L22.043 22.5095C22.8897 22.0781 23.5781 21.3897 24.0095 20.543L23.564 20.316ZM24 16.1H23.5C23.5 17.2284 23.4996 18.0446 23.4472 18.6865C23.3952 19.3226 23.2946 19.7434 23.1185 20.089L23.564 20.316L24.0095 20.543C24.2694 20.0329 24.3868 19.4658 24.4438 18.7679C24.5004 18.0758 24.5 17.2119 24.5 16.1H24ZM24 9.9H23.5V16.1H24H24.5V9.9H24ZM23.564 5.68404L23.1185 5.91103C23.2946 6.25662 23.3952 6.67744 23.4472 7.31352C23.4996 7.95545 23.5 8.77165 23.5 9.9H24H24.5C24.5 8.78815 24.5004 7.92418 24.4438 7.23209C24.3868 6.53416 24.2694 5.9671 24.0095 5.45704L23.564 5.68404ZM21.816 3.93597L21.589 4.38148C22.2475 4.71703 22.783 5.25247 23.1185 5.91103L23.564 5.68404L24.0095 5.45704C23.5781 4.61031 22.8897 3.9219 22.043 3.49047L21.816 3.93597ZM17.6 3.5V4C18.7284 4 19.5446 4.00039 20.1865 4.05284C20.8226 4.10481 21.2434 4.20539 21.589 4.38148L21.816 3.93597L22.043 3.49047C21.5329 3.23058 20.9658 3.11318 20.2679 3.05616C19.5758 2.99961 18.7119 3 17.6 3V3.5ZM13.2859 3.5V4H17.6V3.5V3H13.2859V3.5ZM4 1.5V2H7.71548V1.5V1H4V1.5ZM13.2859 3.5V3C12.494 3 11.6908 2.5772 10.7393 2.06059C9.84898 1.5772 8.81047 1 7.71548 1V1.5V2C8.50738 2 9.31066 2.4228 10.2621 2.93941C11.1525 3.4228 12.191 4 13.2859 4V3.5Z"
      fill="url(#paint0_linear_26102_65985)"
      mask="url(#path-1-inside-1_26102_65985)"
    />
    <rect
      x="0.25"
      y="6.75"
      width="23.5"
      height="15.5"
      rx="3.75"
      fill="#7690BA"
      stroke="url(#paint1_linear_26102_65985)"
      strokeWidth="0.5"
    />
    <rect
      opacity="0.2"
      y="6.5"
      width="24"
      height="16"
      rx="4"
      fill="url(#paint2_linear_26102_65985)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_26102_65985"
        x1="12"
        y1="1.5"
        x2="12"
        y2="22.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.12" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_26102_65985"
        x1="12"
        y1="6.5"
        x2="12"
        y2="22.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.12" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_26102_65985"
        x1="0"
        y1="6.5"
        x2="16.5047"
        y2="21.9612"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

const ForwardRef = forwardRef(FilledFolderCloseIcon);
export default ForwardRef;
